import { Controller } from "@hotwired/stimulus"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

// Connects to data-controller="ckeditor"
export default class extends Controller {
  connect() {
    if (this.editor) return

    const placeholderText = this.element.getAttribute("placeholder")

    ClassicEditor.create(this.element, {
      licenseKey: "GPL",
      placeholder: placeholderText,
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "bulletedList",
        "numberedList",
        "|",
        "undo",
        "redo"
      ]
    })
      .then((editor) => {
        this.editor = editor
        editor.model.document.on("change:data", () => {
          this.element.value = editor.getData()
        })
      })
      .catch((error) => {
        console.error("CKEditor initialization failed", error)
      })
  }

  disconnect() {
    if (!this.editor) return

    const editor = this.editor
    this.editor = null
    editor.destroy().catch((error) => {
      console.error("CKEditor teardown failed", error)
    })
  }
}
